@if (tableData) {
  <google-chart [data]="geoChart" #chart></google-chart>
}
